// import classnames from 'classnames';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { odata } from '@bingads-webui/http-util';
import { Scenario, Activity, withActivityContext } from '@bingads-webui-react/hoc-with-signal';

import {
  getLoggerWithoutPageInfo,
} from '@bingads-webui-campaign-react/asset-library-services';
import {
  getBackgroundChangeODataService,
  getBackgroundChangeRepository,
  getODataConfig,
} from '@bingads-webui-campaign-react/ads-studio-app-shell-cmui';
import { getLogVersion } from '@bingads-webui-campaign-react/asset-library-model';

import { CopilotChangeImageBackgroundView } from '@bingads-webui-campaign-react/copilot-change-image-background-view';

const DialogImpl = ({
  editingImage,
  isOpen,
  onClose,
  onApply,
  aid,
  cid,
  i18n,
  serverContext,
  permissions,
  perfMarker,
  //
  repository,
  activity,
}) => {
  const isReadonly = useMemo(
    () => (permissions && permissions.IsReadOnlyUser)
        || (serverContext && serverContext.CurrentAccountInActive),
    [permissions, serverContext]
  );

  const innerRepository = useMemo(() => {
    const oDataConfig = getODataConfig(serverContext);
    const oDataService = getBackgroundChangeODataService({
      odata, oDataConfig, aid, cid,
    });
    const repo = getBackgroundChangeRepository(oDataService);
    return repo;
  }, [aid, cid, serverContext]);

  const logger = useMemo(() => {
    const versionForLog = getLogVersion(permissions);
    const ret = getLoggerWithoutPageInfo(activity, versionForLog, 'ChangeImageBackgroundDialog');
    return ret;
  }, [activity, permissions]);

  if (isReadonly) {
    // todo: show user some message?
    // onClose();
  }

  return (
    <CopilotChangeImageBackgroundView
      editingImage={editingImage}
      isOpen={isOpen}
      onClose={onClose}
      onApply={onApply}
      repository={repository || innerRepository}
      logger={logger}
      i18n={i18n}
      isReadonly={isReadonly}
      perfMarker={perfMarker}
    />
  );
};

DialogImpl.propTypes = {
  editingImage: PropTypes.shape({ // ImageExperienceImage
    Id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    src: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
    getToday: PropTypes.func,
    formatCivilDate: PropTypes.func,
  }).isRequired,
  repository: PropTypes.shape({
    removeImageBackground: PropTypes.func,
    getImageSegmentations: PropTypes.func,
    generateImageBackground: PropTypes.func,
  }),
  cid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  aid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  permissions: PropTypes.shape({
    IsReadOnlyUser: PropTypes.bool,
    dynamic: PropTypes.shape({
    }).isRequired,
  }).isRequired,
  serverContext: PropTypes.shape({
    CurrentAccountInActive: PropTypes.bool,
    CurrentAccount: PropTypes.shape({}),
    CurrentUser: PropTypes.shape({}),
    ServicesEndpoints: PropTypes.shape({}),
  }).isRequired,
  perfMarker: PropTypes.shape({}).isRequired,
  //
  activity: PropTypes.shape({}).isRequired,
};

DialogImpl.defaultProps = {
  repository: null,
};

const DialogWithActivity = withActivityContext(DialogImpl);

export const CopilotChangeImageBackgroundDialog = props => (
  <Scenario name="CreativeStudioAssetLibrary">
    <Activity name="CreativeStudioAssetLibrary">
      <DialogWithActivity {...props} />
    </Activity>
  </Scenario>
);
